import { IdentityUserProvider } from '@sharedservices/identity-auth-angular';

import { PartnerCenterEnvironment } from './partner-center-environment';

export const environment: PartnerCenterEnvironment = {
    production: true,
    userProvider: IdentityUserProvider,
    apis: {
        prefix: '/api',
        version: 'v1'
    },
};
